import {
  ShareResponse,
  ShareServiceResponse,
} from 'app/components/Shares/types';
import {
  LinkStatus,
  SharedLink,
  SharedPlaylistResponse,
} from 'types/shares.types';

export const getShareItem = (
  data: ShareResponse | SharedPlaylistResponse | null
) =>
  data
    ? {
        ...data?.response.share.item,
        referralId: data?.response.config?.item.referralId,
      }
    : undefined;

export const getAudioItem = (data: ShareResponse | null) =>
  data?.response.audio?.item;

export const getShareLink = (data: ShareServiceResponse | null) =>
  data?.response._links.getPublicShare?.href;

export const getShareLinkV2 = (data: ShareServiceResponse | null) =>
  data?.response._links.getPublicShareV2?.href;

export const isLinkRevoked = (link: SharedLink) =>
  link.status === LinkStatus.REVOKED;

export const formatFetchUrl = (link: string, token: string) =>
  link?.replace('{shareToken}', token);

export const formatFetchUrlV2 = (link: string, token: string) =>
  link?.replace('{uid}', token);
